import {Component, HostListener, OnInit} from '@angular/core';
import {Meta, Title} from "@angular/platform-browser";
import {Router} from "@angular/router";

@Component({
    selector: 'app-aarni-school-of-pharmacy',
    templateUrl: './aarni-school-of-pharmacy.component.html',
    styleUrls: ['./aarni-school-of-pharmacy.component.scss']
})
export class AarniSchoolOfPharmacyComponent implements OnInit {
    testimonialSlideIndex: number = 0;
    testimonialSlidesCount: number = 3;
    testimonials = [
/*        {
            name: 'Pallavi Chauhan',
            course: 'M.sc. - Physics',
            designation: 'J&K Bank',
            image: 'assets/img/home-page-testimonials/pallavi-chauhan.webp',
            feedback: `ARNI University provides an excellent platform to those who have an interest in
                                    research and technology. The professors are well-mannered and talented, ensure
                                    student growth. The laboratory is equipped with all the necessary equipments. The
                                    emphasis on research ethics and
                                    innovation has given me the confidence to pursue my dream of contributing to
                                    physical advancements.`,
        },
        {
            name: 'Punchok Lamo',
            course: 'M.Sc. - Physics',
            designation: 'Govt. Teacher',
            image: 'assets/img/home-page-testimonials/punchok-lamo.webp',
            feedback: `Throughout my learning journey at ARNI University, I was always encouraged to focus
                                    on practical learning. The faculty organized science fairs, conducted open
                                    experiment classes, analyzed our data, and helped to develop critical thinking
                                    skills. Lectures from industry experts keep us updated with real-world scenarios and
                                    boost our confidence.`,
        },*/
        {
            name: 'Vinit Gupta',
            course: 'Diploma in Pharmacy',
            designation: 'Garg Pharma',
            image: 'assets/img/home-page-testimonials/vinit-gupta.webp',
            feedback: `I was a little nervous and worried about the course curriculum when I joined this
                                    program. But the best student support and world-class faculty made everything easy
                                    and synchronized for me. The faculty members are absolutely knowledgeable and always
                                    ready to help whenever required. Apart from theoretical learning, they focus on
                                    applying what we learn. I had a great time here!`,
        },
    ];
    groupedTestimonials: any[][] = [];
    events = [
        {
            date: '04 Nov 2023',
            title: 'Anti Drug Event',
            description: 'ARNI University organized an impactful Anti-Drug Event to raise awareness and promote a drug-free, healthy campus environment.',
            image: 'assets/img/school-wise-faculties/arni-school-of-allied-health-sciences/events/anti-drug-event3.webp'
        },
        {
            image: 'assets/img/home-page-events/image-1.webp',
            date: '15 Oct 2024',
            title: 'Miss-Himachal 2021-2022 in Partnership with Godrej No. 1',
            description: 'ARNI University proudly hosted Miss Himachal 2021-2022 in partnership with Godrej No.1 on 15 Oct 2024 — celebrating talent, confidence, and culture.'
        },
        {
            image: 'assets/img/home-page-events/image-2.webp',
            date: '26 Jan 2024',
            title: 'Republic Day Celebration',
            description: 'ARNI University proudly celebrated Republic Day with a spirited NCC march, showcasing patriotism, discipline, and national pride on campus.'
        },
        {
            image: 'assets/img/home-page-events/image-3.webp',
            date: '19 Oct 2024',
            title: 'Special Convocational Ceremony',
            description: 'At ARNI University on February 1, to confer an honorary doctorate on Maj Gen Abhay Dayal, VSM for his immense contributions to the field of National Security (Army).'
        }
    ];
    departments = [
        /*    {
                name: 'Post Graduate',
                icon: 'fa-pills',
                branches: [
                    'M. Pharmacy Pharmaceutics',
                    'M. Pharmacy Pharmacognosy',
                    'M. Pharmacy Pharmacology',
                    'M. Pharmacy Pharmaceutical Chemistry'
                ]
            },*/
        {
            name: 'Diploma',
            icon: 'fa-pills',
            branches: [
                'D.Pharmacy',
            ]
        },
        {
            name: 'Undergraduate',
            icon: 'fa-pills',
            branches: [
                'B.Pharmacy',
            ]
        }
    ];
    faculties = [
        {
            name: 'Dr. Neeraj Bhandari',
            designation: 'Dean, ARNI School of Pharmacy',
            image: 'assets/img/school-wise-faculties/arni-school-of-pharmacy/dr-neeraj-bhandari-arni-school-of-pharmacy.webp',
        },
        {
            name: 'Aman Sharma',
            designation: 'Assistant Professor, ARNI School of Pharmacy',
            image: 'assets/img/school-wise-faculties/arni-school-of-pharmacy/aman-sharma-arni-school-of-pharmacy.webp',
        },
        {
            name: 'Anjali',
            designation: 'Assistant Professor, ARNI School of Pharmacy',
            image: 'assets/img/assistant-professor/anjali-assistant-professor-pharmacy.jpeg',
        },
        {
            name: 'Ankush Kumar',
            designation: 'Assistant Professor, ARNI School of Pharmacy',
            image: 'assets/img/school-wise-faculties/arni-school-of-pharmacy/ankush-kumar-assistant-professor.png',
        },
        {
            name: 'Ankush Sharma',
            designation: 'Assistant Professor, ARNI School of Pharmacy',
            image: 'assets/img/school-wise-faculties/arni-school-of-pharmacy/ankush-sharma-assistant-professor.png',
        },
    ];
    index = 0;
    recruiters = [
        {name: "Adani Wilmar", logo: "assets/img/companies/adani_wilmar.png"},
        {name: "Amar Ujala", logo: "assets/img/companies/amarujala.png"},
        {name: "Amazon", logo: "assets/img/companies/Amazon.png"},
        {name: "CMC", logo: "assets/img/companies/cmc-logo_0.png"},
        {name: "Dish TV", logo: "assets/img/companies/Dish_TV_2.png"},
        {name: "Future Group", logo: "assets/img/companies/FutureGroup.png"},
        {name: "HCL", logo: "assets/img/companies/hcl.png"},
        {name: "ICICI", logo: "assets/img/companies/icici_securities.png"},
        {name: "Sleepwell", logo: "assets/img/companies/sleepwell.png"},
        {name: "SYNTEL", logo: "assets/img/companies/syntel2.png"},
        {
            name: "Tech Mahindra",
            logo: "assets/img/companies/Tech_Mahindra_New_Logo1.png",
        },
        {name: "Vodafone", logo: "assets/img/companies/Vodafone_logo.png"},
        {name: "Zee TV", logo: "assets/img/companies/Zee_TV_2011.png"},
        {name: "Genpact", logo: "assets/img/companies/zenpact.png"},
        {name: "Reliance", logo: "assets/img/companies/amarujala.png"},
    ];

    nextSlide() {
        if (this.index < this.recruiters.length - 3) {
            this.index++;
        }
    }

    prevSlide() {
        if (this.index > 0) {
            this.index--;
        }
    }

    currentIndex = 0;
    translateX = 0;

    constructor(
        private meta: Meta,
        private titles: Title,
        private router: Router
    ) {
    }

    ngOnInit(): void {
        window.scrollTo(0, 0);
        this.updateMetaTags();
        this.scrollToContent();
        this.groupTestimonials()

    }

    scrollToContent() {
        const tabs = document.querySelectorAll('.tab-link');
        const tabContainer = document.querySelector('.tab-buttons'); // tab buttons wrapper
        const header = document.querySelector('header'); // your fixed header element, if any

        const tabHeight = tabContainer?.getBoundingClientRect().height || 0;
        const headerHeight = header?.getBoundingClientRect().height || 0;

        const totalOffset = tabHeight + headerHeight + 15; // add extra padding to show section clearly

        tabs.forEach(tab => {
            tab.addEventListener('click', (event: Event) => {
                event.preventDefault();

                tabs.forEach(t => t.classList.remove('active-tab'));
                (event.target as HTMLElement).classList.add('active-tab');

                const targetId = (event.target as HTMLElement).getAttribute('href')?.substring(1);
                if (targetId) {
                    const targetElement = document.getElementById(targetId);
                    if (targetElement) {
                        const y = targetElement.getBoundingClientRect().top + window.pageYOffset - totalOffset;
                        window.scrollTo({top: y, behavior: 'smooth'});
                    }
                }
            });
        });
    }

    goTo(url: string) {
        this.router.navigateByUrl(url);
    }

    prev() {
        if (this.currentIndex > 0) {
            this.currentIndex--;
            this.translateX = -this.currentIndex * 25; // Move 25% left
        }
    }

    next() {
        if (this.currentIndex < this.faculties.length - 1) {
            this.currentIndex++;
            this.translateX = -this.currentIndex * 25; // Move 25% right
        }
    }

    setTestimonialSlide(index: number) {
        this.testimonialSlideIndex = index;
    }


    @HostListener('window:resize')
    onResize() {
        this.groupTestimonials();
    }

    groupTestimonials(): void {
        const screenWidth = window.innerWidth;
        let perSlide = 1;
        if (screenWidth >= 1024) {
            perSlide = 3;
        } else if (screenWidth >= 768) {
            perSlide = 2;
        } else {
            perSlide = 1;
        }
        const grouped = [];
        for (let i = 0; i < this.testimonials.length; i += perSlide) {
            grouped.push(this.testimonials.slice(i, i + perSlide));
        }
        this.groupedTestimonials = grouped;
        if (this.testimonialSlideIndex >= this.groupedTestimonials.length) {
            this.testimonialSlideIndex = 0;
        }
    }

    updateMetaTags() {
        this.titles.setTitle('Undergraduate Courses for Science Students at AARNI School');
        this.meta.updateTag({
            name: 'description',
            content: `Explore undergraduate courses for science students at AARNI School of Pharmacy. Prepare for a successful career with a top-tier education and hands-on experience.`
        });
    }
}
